import React from "react";

export default function Footer() {
  return (
    <footer className="py-16 font-sans bg-white border-t border-slate-50">
      <div className="flex flex-col items-center px-6 mx-auto max-w-7xl">
        
        {/* LOGO AVEC PETIT ACCENT */}
        <div className="flex flex-col items-center gap-4">
          <img 
            src="/fulllogo_transparent_nobuffer.png" 
            alt="Souqi Logo" 
            className="h-10 transition-all duration-500 opacity-50 grayscale hover:grayscale-0 hover:opacity-100" 
          />
          <div className="w-8 h-1 bg-red-100 rounded-full"></div>
        </div>

        {/* COPYRIGHT */}
        <p className="mt-10 text-[10px] font-black text-slate-300 uppercase tracking-[0.3em] text-center">
          © {new Date().getFullYear()} Souqi • Mauritanie
        </p>
      </div>
    </footer>
  );
}